var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search-contain" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "中奖时间", prop: "daterange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.daterange,
                      callback: function ($$v) {
                        _vm.daterange = $$v
                      },
                      expression: "daterange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入奖品名称或ID", clearable: "" },
                    model: {
                      value: _vm.query.prize,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "prize",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.prize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建人" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入操作人姓名", clearable: "" },
                    model: {
                      value: _vm.query.createAt,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "createAt",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.createAt",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖品类型", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.query.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "type", $$v)
                        },
                        expression: "query.type",
                      },
                    },
                    _vm._l(_vm.typeList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.search },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("清空")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.add },
                    },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yd-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.records,
            border: "",
            size: "mini",
            pagination: _vm.pagination,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: { label: "奖品ID", prop: "id", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "奖品名称",
              prop: "prizeName",
              align: "center",
              "min-width": "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "奖品类型",
              prop: "prizeType",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(_vm.typeList, function (item) {
                    return _c("div", { key: item.value }, [
                      _vm._v(
                        _vm._s(
                          scope.row.prizeType === item.value ? item.label : ""
                        )
                      ),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "价值",
              prop: "price",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.price / 100) +
                          _vm._s(scope.row.prizeType === 2 ? "元" : "")
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建人",
              prop: "createUser",
              align: "center",
              "min-width": "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建时间",
              prop: "createTime",
              align: "center",
              width: "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              prop: "createUserName",
              align: "center",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editShow
        ? _c("Edit", {
            attrs: { visible: _vm.editShow, formData: _vm.editData },
            on: { close: _vm.editClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }